import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { images } from "../data/siteContent";
import styles from "./Navbar.module.css";

export const CustomNavbar = () => {
  const navigate = useNavigate();

  const handleScroll = (id) => {
    // Navigate to home first if not already there
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToElement(id), 100);
    } else {
      scrollToElement(id);
    }
  };

  const scrollToElement = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = -120;
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition + offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" sticky="top">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img className={styles.logo} alt="Hood Shaw Memorial Logo" src={images.logo} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link className={styles.navLink} onClick={() => handleScroll("about")}>
              About
            </Nav.Link>
            <Nav.Link className={styles.navLink} onClick={() => handleScroll("pastor")}>
              Team
            </Nav.Link>
            <Nav.Link className={styles.navLink} as={Link} to="/news">
              News
            </Nav.Link>
            <Nav.Link className={styles.navLink} onClick={() => handleScroll("donations")}>
              Donate
            </Nav.Link>
            <Nav.Link className={styles.navLink} onClick={() => handleScroll("contact")}>
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
